import {useAxiosClient} from "~/use/axios/client";
import {EntrepreneurApi, GmModelLibraryModelsEntrepreneurModel} from "~/gen/openapi/sblService";
import {keepPreviousData, useQuery, UseQueryOptions} from "@tanstack/vue-query";
import {MS_HOUR} from "~/constants/time";
import {orderBy} from "lodash";
import {queryClient} from "~/plugins/vue-query";

export const useEntrepreneurService = () => {
    const { axiosClient } = useAxiosClient()
    const entrepreneurApi = new EntrepreneurApi(undefined, '', axiosClient.value)

    const entrepreneursQueryOptions: UseQueryOptions<GmModelLibraryModelsEntrepreneurModel[]> = {
        queryKey: ['entrepreneurGetEntrepreneurs'],
        queryFn: async () => {
            return orderBy((await entrepreneurApi.entrepreneurGetEntrepreneurs())?.data, 'ParentName')
        },
        staleTime: MS_HOUR,
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
        gcTime: Infinity,
    }

    const entrepreneursQuery = () => useQuery(entrepreneursQueryOptions)

    const getEntrepreneurById = (id: string) => {
        const entrepreneurs = (queryClient.getQueryData(entrepreneursQueryOptions.queryKey) || []) as GmModelLibraryModelsEntrepreneurModel[]
        return entrepreneurs.find((e) => e.Id === id)
    }

    const getEntrepreneurNameById = (id: string) => {
        return getEntrepreneurById(id)?.Name || ''
    }

    const entrepreneurs = computed(() => (queryClient.getQueryData(entrepreneursQueryOptions.queryKey) || []) as GmModelLibraryModelsEntrepreneurModel[])

    return {
        entrepreneursQueryOptions,
        entrepreneursQuery,
        getEntrepreneurById,
        getEntrepreneurNameById,
        entrepreneurs,
    }
}